<template>
  <div class="complain-container">
    <HeaderO :title="title"></HeaderO>
    <div class="main-containe">
      <div class="title">产品信息</div>
      <van-cell-group>
        <van-field
          v-model="form.complaintTitle"
          required
          label="标题"
          placeholder="请输入标题"
        />
        <!-- <van-field v-model="form" required label="投诉类型" placeholder="请输入标题" /> -->
      </van-cell-group>
      <input
        v-model="form.complaintType"
        style="display: none;"
      />
      <input
        v-model="form.orgCode"
        style="display: none;"
      />
      <div class="complain-dropdown-menu">
        <label><span class="red">*</span><span class="span">投诉类型</span></label>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="complaintTypeList.value"
            @change="complaintType(complaintTypeList.value)"
            :options="complaintTypeList"
          />
        </van-dropdown-menu>
      </div>
      <div class="complain-dropdown-menu">
        <label><span class="red">*</span><span class="span">销售公司</span></label>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="salesCompanyList.value"
            @change="orgCode(salesCompanyList.value, salesCompanyList.text)"
            :options="salesCompanyList"
          />
        </van-dropdown-menu>
      </div>
      <div
        class="order-code"
        v-if="form.complaintType !='06'"
      >
        <van-cell
          is-link
          @click="showPopup(1)"
        >
          <van-field
            v-model="form.orderCode"
            readonly
            required
            label="订单编号"
            placeholder="请输入订单编号"
          />
        </van-cell>
      </div>
      <van-cell-group>
        <van-field
          v-if="form.complaintType !='06'"
          readonly
          v-model="form.purchaseTime"
          label="购货日期"
          placeholder="请输入购货日期"
        />
        <van-field
          v-if="form.complaintType !='06'"
          readonly
          v-model="form.unitPrice"
          label="成交单价"
          placeholder="请输入成交单价"
        />
        <van-field
          v-if="form.complaintType !='06'"
          readonly
          v-model="form.purchaseQuantity"
          label="购货量（吨）"
          placeholder="请输入购货量（吨）"
        />
        <van-field
          v-if="form.complaintType !='06'"
          readonly
          required
          v-model="form.unitList"
          label="生产企业"
          placeholder="请输入生产企业"
        />

      </van-cell-group>
      <van-cell-group>
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.deliveryOrderCode"
          label="交货单编号"
          placeholder="请输入标题"
        />
        <!-- <van-field v-model="form.deliveryOrderCode"  label="交货单编号" placeholder="请输入标题" /> -->
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.deliveryQuantity"
          type="number"
          label="交货单量"
          placeholder="请输入交货单量"
        />
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.productName"
          readonly
          required
          label="产品名称"
          placeholder="请输入产品名称"
        />
      </van-cell-group>
      <!-- <div class="order-code" v-if="isShowItem('其他投诉', 0)">
       <van-cell is-link @click="showPopup(2)">
         <van-field  v-model="form.productName" readonly  required label="产品名称" placeholder="请输入产品名称" />
       </van-cell>
      </div> -->
      <van-cell-group>
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.materialCode"
          label="物料编码"
          placeholder="请输入物料编码"
        />
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.productBatch"
          label="产品批次"
          placeholder="请输入产品批次"
        />
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.productMark"
          label="产品牌号"
          placeholder="请输入产品牌号"
        />
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.productLevel"
          label="产品等级"
          placeholder="请输入产品等级"
        />
        <van-field
          v-if="form.complaintType =='01' || form.complaintType =='02' || form.complaintType =='05'"
          v-model="form.useAmount"
          required
          label="已用量（吨）"
          placeholder="请输入已用量（吨）"
        />
        <van-field
          v-if="form.complaintType !='06'"
          v-model="form.claimAmount"
          type="number"
          label="索赔金额"
          placeholder="请输入索赔金额"
        />
        <van-field
          v-if="form.complaintType =='01' || form.complaintType =='02'"
          type="number"
          v-model="form.damageAmount"
          label="受损量"
          placeholder="请输入受损量"
        />
      </van-cell-group>
      <div
        class="complain-dropdown-menu"
        v-if="form.complaintType =='03'"
      >
        <label><span class="red">*</span><span class="span">运输方式</span></label>
        <van-dropdown-menu>
          <van-dropdown-item
            v-model="transportTypeList.value"
            @change="transportType(transportTypeList.value)"
            :options="transportTypeList"
          />
        </van-dropdown-menu>
      </div>
      <van-cell-group>
        <van-field
          required
          v-if="form.complaintType =='03'"
          v-model="form.vehicleCount"
          label="车辆数量"
          placeholder="请输入车辆数量"
        />
        <van-field
          required
          v-if="form.complaintType =='03'"
          v-model="form.vehicleNumber"
          label="车牌号"
          placeholder="请输入车牌号"
        />
        <van-field
          v-if="form.complaintType =='05'"
          v-model="form.returnRequestQuantity"
          label="申请退货数量"
          placeholder="请输入申请退货数量"
        />
      </van-cell-group>
      <div class="title">问题描述</div>
      <van-field
        v-model="form.complaintDesc"
        rows="5"
        type="textarea"
        placeholder="请输入请输入问题描述"
      />
      <div class="title">申请信息</div>
      <van-cell-group>
        <van-field
          v-model="form.companyName"
          readonly
          required
          label="公司名称"
          placeholder="请输入公司名称"
        />
        <van-field
          v-model="form.contactorName"
          required
          label="联系人"
          placeholder="请输入联系人"
        />
        <van-field
          v-model="form.contactorMobile"
          required
          label="电话"
          placeholder="请输入电话"
        />
        <van-field
          v-model="form.contactorEmail"
          label="邮箱"
          placeholder="请输入邮箱"
        />
      </van-cell-group>
      <div class="title">附件</div>
      <!-- <div class="file">
        <van-uploader
          v-model="fileList"
          multiple
          :max-size="500 * 1024"
          @oversize="onOversize"
        />
      </div> -->

    </div>
    <div class="btn-order">
      <div class="card-btn">
        <van-button
          class="btn"
          @click="submitBtn('02')"
        >提交</van-button>
      </div>
    </div>
    <van-popup v-model="showOrder">
      <SelectOrder
        @returnOrderBtn="returnOrderBtn"
        @orderSelect="orderSelect"
      ></SelectOrder>
    </van-popup>
    <van-popup v-model="showProduct">
      <SelectProduct
        :form="form"
        @returnBtn="returnBtn"
        :showProduct="showProduct"
        @sureChange="sureChange"
      ></SelectProduct>
    </van-popup>

  </div>

</template>
<script>
import HeaderO from "@/components/HeaderO.vue";
import transactionApi from "@/request/transactionApi";
import planSaleApi from "@/request/planSaleApi";
import { getStore } from "@/store/storage.js";
import SelectOrder from "@/components/SelectOrder.vue";
import SelectProduct from "@/components/SelectProduct.vue";
export default {
  name: "ComplaintList",
  components: {
    HeaderO,
    SelectOrder,
    SelectProduct,
  },
  data() {
    return {
      showOrder: false,
      showProduct: false,
      title: "新增投诉",
      form: {
        complaintPicUrl :"",
        complaintTitle: "",
        complaintType: "",
        orderCode: "",
        orderNo: "",
        purchaseTime: "",
        unitPrice: "",
        purchaseQuantity: "",
        deliveryOrderCode: "",
        deliveryQuantity: "",
        productName: "",
        materialCode: "",
        productBatch: "",
        productMark: "",
        productLevel: "",
        claimAmount: "",
        useAmount: "",
        damageAmount: "",
        complaintDesc: "",
        contactorName: "",
        companyName: "",
        contactorMobile: "",
        contactorEmail: "",
        complaintStatus: "01",
        quantity: "",
        orgCode:"",
        orgName:"",
        returnRequestQuantity:'',

      },
      showFormStr: "产品质量投诉",
      salesCompanyList: [],
      complaintTypeList: [
        { text: "产品质量投诉", value: "01" },
        { text: "产品计量投诉", value: "02" },
        { text: "运输批次投诉", value: "03" },
        { text: "包装破损投诉", value: "04" },
        { text: "退货申请", value: "05" },
        { text: "其他投诉", value: "06" },
      ],
      unitList: [
        { value: "抚顺石化" },
        { value: "吉林石化" },
        { value: "兰州石化" },
      ],
      transportTypeList: [
        { text: "汽运", value: "01" },
        { text: "海运", value: "02" },
        { text: "铁运", value: "03" },
      ],
      fileList: [],
    };
  },
  watch: {},
  mounted() {
    this.form.companyName = getStore("userInfo").companyAuthModel.companyName;
    this.getsalesCompanyList();
    console.log("jklkk", this.$route.query.companyComplaintId)
    if (this.$route.query.companyComplaintId) {
      this.getList();
      this.title = "编辑投诉";
    }
  },
  methods: {
    //获取销售公司
    getsalesCompanyList() {
      // const data = JSON.parse(localStorage.getItem("usererpInfo"));
      let params = Object.assign(
        { pageNum: 1, pageSize: 99999 },
        this.searchLimit
      );
      planSaleApi.getSellerList(params).then((res) => {
        if (res.returnCode == "0") {
          // this.salesCompanyList = [];
          res.result.forEach((item) => {
            this.salesCompanyList.push({
              text: item.orgName,
              value: item.orgCode,
            });
          });
          console.log("000orgCode", this.salesCompanyList);
          // this.$forceUpdate();
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
      // console.log(res.data.result);
    },
    complaintType(value) {
      this.form.complaintType = value;
    },
    orgCode(value, text) {
      this.form.orgCode = value;
      this.form.orgName = text;
    },
    transportType(value) {
      this.form.transportType = value;
    },
    showPopup(type) {
      console.log("00000", type);
      if (type == "1") {
        this.showOrder = true;
      } else {
        this.showProduct = true;
      }
    },
    onOversize(file) {
      console.log(file);
      this.$toast("文件大小不能超过 500kb");
    },
    orderSelect(val) {
      let orderDetail = val.orderDetailInfoList[0];
      this.form.orderCode = orderDetail.orderNo;
      this.form.productMark = orderDetail.commoditySpec;
      this.form.productLevel = orderDetail.grade;
      this.form.unitList = orderDetail.productionEnterprise;
      this.form.purchaseQuantity = orderDetail.quantity;
      this.form.productName = orderDetail.commodityName;
      this.form.materialCode = orderDetail.materialCode;
      this.form.unitPrice = orderDetail.price;
      let date = new Date(val.createTime);
      let month = date.getMonth();
      let day = date.getDate();
      this.form.purchaseTime =
        date.getFullYear() +
        "-" +
        (month > 9 ? month : "0" + month) +
        "-" +
        (day > 9 ? day : "0" + day);
      this.showOrder = false;
    },
    // // 商品查询列表
    // getProductlist() {
    //   // this.showModal = true;
    //   let params = {};
    //   params.currentPage = this.pageInfo.currentPage;
    //   params.pageSize = this.pageInfo.pageSize;
    //   params.commodityName = this.search.commodityName;
    //   // params.sellerName=this.form.sellerName

    //   transactionApi.getProductList(params).then((res) => {
    //     if (res.returnCode == "0") {
    //       for (var i in this.pageInfo) {
    //         this.pageInfo[i] = res.result[i];
    //       }
    //       this.dataList = res.result.dataList;
    //       this.pageInfo.total = res.result.totalRows;
    //     } else {
    //       this.$toast({
    //         type: "fail",
    //         message: res.returnMessage,
    //         duration: 1500,
    //       });
    //     }
    //   });
    // },

    sureChange(data) {
      console.log("000", data);
      this.form.productName = data.productName;
      this.form.unitList = data.manufacturer;
      this.form.productMark = data.spec;
      this.form.productLevel = data.grade;

      // this.form.productName = data.commodityName;

      this.showProduct = false;
    },

    // 详情
    getList() {
      let companyComplaintId = this.$route.query.companyComplaintId;
      transactionApi.getdetail({ companyComplaintId }).then((res) => {
        if (res.returnCode == "0") {
          // result=this.ry_timeFilter(result.complaintTime)
          // let obj = {
          //   category: "06",
          //   companyComplaintId: 366,
          //   companyComplaintLogId: 415,
          //   createTime: 1610007319000,
          //   createUserId: 95,
          //   createUserName: "华北管理员",
          //   picName: "",
          //   picUrl: "",
          //   remark: "",
          // };
          // let obj2 = {
          //   category: "03",
          //   companyComplaintId: 366,
          //   companyComplaintLogId: 415,
          //   createTime: 1610007319000,
          //   createUserId: 95,
          //   createUserName: "华北管理员",
          //   picName: "",
          //   picUrl: "",
          //   remark: "",
          // };
          if (res.result.companyComplaintLogModelList.length <= 2) {
            // res.result.companyComplaintLogModelList.push(obj);
            // res.result.companyComplaintLogModelList.push(obj2);
          }
          console.log("----",res.result);
          this.form = res.result;
          this.complaintTypeList.value = this.form.complaintType;
          if (this.form.complaintExtraModel.transportType) {
            this.transportTypeList.value = this.form.complaintExtraModel.transportType;  
          }
          this.salesCompanyList.value = this.form.orgCode;

          this.form.complaintPicName = this.form.complaintExtraModel.complaintPicName;
          this.form.deliveryQuantity = this.form.complaintExtraModel.deliveryQuantity;
          this.form.materialCode = this.form.complaintExtraModel.materialCode;
          this.form.productBatch = this.form.complaintExtraModel.productBatch;
          this.form.productLevel = this.form.complaintExtraModel.productLevel;
          this.form.productMark = this.form.complaintExtraModel.productMark;
          this.form.productName = this.form.complaintExtraModel.productName;
          this.form.unitList = this.form.complaintExtraModel.productor;
          this.form.purchaseQuantity = this.form.complaintExtraModel.purchaseQuantity;
          this.form.purchaseTime = this.$utils.formatDate(
            this.form.complaintExtraModel.purchaseTime
          );
          this.form.returnRequestQuantity = this.form.complaintExtraModel.returnRequestQuantity;
          this.form.unitPrice = this.form.complaintExtraModel.unitPrice;
          this.form.vehicleCount = this.form.complaintExtraModel.vehicleCount;
          this.form.vehicleNumber = this.form.complaintExtraModel.vehicleNumber;

          if (res.result.complaintStatus == "09") {
            this.flag = true;
          } else {
            this.flags = true;
          }
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
    returnBtn() {
      this.showProduct = false;
    },
    returnOrderBtn() {
      this.showOrder = false;
    },
    submitBtn(status) {
      console.log(status);
      this.saveComplaint(status);
    },
    saveComplaint(demandStatus) {
      this.form.complaintStatus = demandStatus;
      if (this.form.complaintTitle == "") {
        return this.$toast.fail("请输入标题");
      }
      if (this.form.complaintType == "") {
        return this.$toast.fail("请选择投诉类型");
      }
      if (this.form.orgCode == "") {
        return this.$toast.fail("请选择销售公司");
      }
      if (this.form.complaintType == "03") {
        if (this.form.orderCode == "") {
          return this.$toast.fail("请选择订单编号");
        }
        if (this.form.productName == "") {
          return this.$toast.fail("请选择产品名称");
        }
        if (this.form.transportType == "") {
          return this.$toast.fail("请选择运输方式");
        }
        if (this.form.vehicleCount == "") {
          return this.$toast.fail("请输入车辆数量");
        }
        if (this.form.vehicleNumber == "") {
          return this.$toast.fail("请输入车牌号");
        }
      } else if (this.form.complaintType != "06") {
        if (this.form.orderCode == "") {
          return this.$toast.fail("请选择订单编号");
        }
        if (this.form.productName == "") {
          return this.$toast.fail("请选择产品名称");
        }
        if (this.form.unitList == "") {
          return this.$toast.fail("请输入生产企业");
        }
      }

      if (this.form.complaintType == "01" || this.form.complaintType == "02") {
        if (this.form.useAmount == "") {
          return this.$toast.fail("请输入已用量");
        }
      }

      if (this.form.companyName == "") {
        return this.$toast.fail("请输入公司名称");
      }
      if (this.form.contactorName == "") {
        return this.$toast.fail("请输入联系人");
      }
      if (this.form.contactorMobile == "") {
        return this.$toast.fail("请输入联系电话");
      }

      let params = Object.assign({}, this.form);
      transactionApi.saveComplaint(params).then((res) => {
        if (res.returnCode == "0") {
          this.$dialog
            .alert({
              title: "提示",
              message: "操作成功",
            })
            .then(() => {
              this.$router.push("/complaintList");
            })
            .catch(() => {});
        } else {
          this.$toast({
            type: "fail",
            message: res.returnMessage,
            duration: 1500,
          });
        }
      });
    },
  },
};
</script>
<style lang="stylus" scoped>
.complain-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.main-containe {
  flex: 1;
  height: 85vh;
  position: absolute;
  padding: 0 20px;
  top: 0.88rem;
  left: 0;
  right: 0;
  // bottom: 0.88rem;
  font-size: 28px;
  overflow: auto;
}

.red {
  color: #ee0a24;
  font-size: 0.14rem;
}

.complain-container >>> .van-cell-group {
  background-color: #f6f4f5;
}

.complain-container >>> .van-field__label {
  width: 180px;
  font-size: 26px;
}

.complain-dropdown-menu >>> .van-cell {
  line-height: 50px;
}

.complain-container >>> .van-cell--required::before {
  left: 20px;
}

.complain-container >>> .van-popup {
  max-width: 95%;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title {
  line-height: 50px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__bar {
  border: 1px solid #666;
  background: #F4F4F4;
  border-radius: 10px;
}

.complain-dropdown-menu >>> .van-dropdown-menu__title::after {
  border: 10px solid;
  border-color: transparent transparent #dcdee0 #dcdee0;
  right: -20px;
  margin-top: -14px;
}

.complain-container .order-code >>> .van-cell.van-cell--clickable {
  padding: 0 30px 0 0;
  line-height: 50px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__title.van-field__label {
  padding-left: 28px;
}

.complain-container .order-code >>> .van-cell__title {
}

.complain-container .order-code >>> .van-cell.van-field {
  padding: 20px 0 20px 0;
}

.complain-container .van-cell-group >>> .van-cell {
  line-height: 50px;
  padding: 20px 30px;
  margin-top: 10px;
}

.complain-container .order-code >>> .van-cell__right-icon {
  margin-left: 0.04rem;
  color: #969799;
  line-height: 50px;
  font-size: 30px;
  vertical-align: middle;
}

.complain-container {
  .title {
    font-size: 30px;
    height: 50px;
    line-height: 50px;
    padding: 20px 30px;
  }

  .file {
    min-height: 200px;
    background: #fff;
    padding: 20px 30px;
  }

  .complain-dropdown-menu {
    background: #fff;
    line-height: 50px;
    // padding: 20px 30px;
    margin-top: 10px;

    label {
      display: inline-block;
      width: 180px;
      font-size: 26px;
      padding-left: 20px;
    }

    .van-dropdown-menu {
      display: inline-block;
      padding: 20px 30px 20px 0;
      line-height: 50px;
      vertical-align: middle;
      width: calc(100% - 250px);
    }
  }
}

.btn-order {
  position: absolute;
  bottom: 2px;
  width: 100%;
  background: #fff;

  span {
    text-align: center;
    display: inline-block;
    width: 35%;
  }

  .card-btn {
    text-align: center;
    height: 100px;
    line-height: 100px;

    .btn {
      width: 90%;
      height: 80px;
      text-align: center;
      background: linear-gradient(132deg, #EF9623 0%, #E12020 100%);
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>